export const PROPERTY_BASED_STYLING_MODEL_DIMENSION_HEIGHT_NAME = "height";
export const PROPERTY_BASED_STYLING_MODEL_DIMENSION_WIDTH_NAME = "width";
export const PROPERTY_BASED_STYLING_MODEL_DIMENSION_LENGTH_NAME = "length";

export type PropertyBasedStylingModelDimensionPropertyNames =
    | typeof PROPERTY_BASED_STYLING_MODEL_DIMENSION_HEIGHT_NAME
    | typeof PROPERTY_BASED_STYLING_MODEL_DIMENSION_WIDTH_NAME
    | typeof PROPERTY_BASED_STYLING_MODEL_DIMENSION_LENGTH_NAME;
